export default "__VITE_ASSET__CHS89UaE__"